let adminAccess = ["arnav", "tariq"];

export default adminAccess;
